import React from 'react';
import FormikTextField from '../FormikTextField';

const FormikCurrencyField = props => <FormikTextField iconPrefix={<span>$</span>} {...props} />;

export default FormikCurrencyField;
